import { render, staticRenderFns } from "./ForthingHistory.vue?vue&type=template&id=112fcffe&scoped=true&"
import script from "./ForthingHistory.vue?vue&type=script&lang=js&"
export * from "./ForthingHistory.vue?vue&type=script&lang=js&"
import style0 from "./ForthingHistory.vue?vue&type=style&index=0&id=112fcffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112fcffe",
  null
  
)

export default component.exports